import {
  Box,
  Typography,
  MenuItem as UnstyledMenuIem,
  styled,
} from "@mui/material";
import { Link as UnstyledLink } from "react-router";

import { IconButton } from "@citrine/atoms/icon-button";
import { TruncatedText } from "@citrine/atoms/truncated-text";
import { DEFAULT_SKEW } from "@citrine/utils/skew";

import { TeamInfo } from "#src/components/team-info";

export const Header = styled("div")(({ theme }) => ({
  display: "flex",
  backgroundColor: theme.palette.grey[800],
  color: theme.palette.common.white,
  alignItems: "stretch",
}));

const NameBase = styled(TruncatedText)({
  flex: 5,
});

export const Name = styled(
  ({ className, ...props }: React.ComponentProps<typeof NameBase>) => (
    <NameBase {...props} tooltipClasses={{ tooltip: className }} />
  ),
)(({ theme }) => ({
  "&&&": {
    margin: theme.spacing(1, 0, 0, 1),
  },
}));

export const Link = styled(UnstyledLink)(({ theme }) => ({
  color: theme.palette.common.white,
  textDecoration: "none",
  alignItems: "center",
  display: "flex",
  height: "100%",
  overflow: "hidden",
  padding: theme.spacing(0, 2),
}));

export const NameText = styled(Typography)({
  textOverflow: "ellipsis",
  overflow: "hidden",
});

export const TeamContainer = styled(TruncatedText)(({ theme }) => ({
  backgroundColor: theme.palette.grey[300],
  flex: 3,
  padding: theme.spacing(1, 2),
  transform: `skew(-${DEFAULT_SKEW}rad)`,
  transformOrigin: "top",
}));

const TeamBase = styled(TeamInfo)(({ theme }) => ({
  color: theme.palette.common.black,
  transform: `skew(${DEFAULT_SKEW}rad)`,
}));

export const Team = styled(
  ({ className, ...props }: React.ComponentProps<typeof TeamBase>) => (
    <TeamBase {...props} classes={{ name: className }} />
  ),
)({
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const Description = styled(Typography)({
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const CardData = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateRows: `${theme.spacing(3)} 1fr ${theme.spacing(3)}`,
  gap: theme.spacing(2),
  gridTemplateColumns: "100%",
  opacity: 1,
  padding: theme.spacing(2, 3, 3),
}));

export const CardDataRow = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(3),
  transform: "none",
}));

export const Number = styled("span")(({ theme }) => ({
  fontFamily: theme.typography.fontFamilyMono,
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.spacing(2),
  letterSpacing: 0.5,
  color: theme.palette.text.primary,
}));

export const NumberContainer = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(0.5),
  alignItems: "center",
}));

export const MenuButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.common.white,
  justifySelf: "right",
}));

export const MenuItem = styled(UnstyledMenuIem)(({ theme }) => ({
  gap: theme.spacing(1),
}));
